import React, { useEffect, useState } from "react";
import EmailVerify from "../Components/EmailVerify";
import SiteSettings from "../Components/SiteSettings/SiteSettings";
import { useParams, useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import Colors from "../Components/SiteSettings/Colors";
import ContactSocial from "../Components/SiteSettings/ContactSocial";
import SEO from "../Components/SiteSettings/SEO";
import Features from "../Components/SiteSettings/Features";
import Payment from "../Components/SiteSettings/Payment";
import EmailSMScfg from "../Components/SiteSettings/EmailSMScfg";
import Security from "../Components/SiteSettings/Security";
import CustomCode from "../Components/SiteSettings/CustomCode";
import { oneKlicks } from "../../SDK/oneclick";
import { OneKlicksFileSDK } from "../../SDK/OneKlicksFileSDK";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
import { getuserdata, getpermissions } from "../../services/apiService";
import Preloader from "../../Uitiles/Preloader";
import ApisConfig from "../Components/SiteSettings/ApisConfig";
import { exportSettings, getSettings, importSettings, initializeDatabase, resetSettingsToDefault, updateMultipleSettings, updateSetting } from "../../services/settingsService";
import WhatsappConfig from "../Components/SiteSettings/WhatsappConfig";


const SuperAdminSiteSettings = () => {

    const [settings, setSettings] = useState({
        site_name: '',
        site_description: '',
        site_email: '',
        site_phone: '',
        site_address: '',
        site_logo: null,
        site_logo_url: null,
        site_favicon: null,
        site_favicon_url: null,
        site_currency: 'USD',
        site_timezone: 'UTC',
        site_url: '',
        site_keywords: ''
    });
    const [colors, setColors] = useState({
        primary_color: '#007bff',
        secondary_color: '#6c757d',
        success_color: '#28a745',
        danger_color: '#dc3545',
        warning_color: '#ffc107',
        info_color: '#17a2b8',
        light_color: '#f8f9fa',
        dark_color: '#343a40',
        text_color: '#212529',
        text_light_color: '#6c757d',
        background_color: '#ffffff',
        background_light_color: '#f8f9fa',
        border_color: '#dee2e6',
        link_color: '#007bff',
        link_hover_color: '#0056b3',
        button_primary_color: '#007bff',
        button_primary_hover_color: '#0056b3',
        button_secondary_color: '#6c757d',
        button_secondary_hover_color: '#545b62',
        header_background_color: '#ffffff',
        header_text_color: '#212529',
        footer_background_color: '#343a40',
        footer_text_color: '#ffffff',
        sidebar_background_color: '#f8f9fa',
        sidebar_text_color: '#212529',
        card_background_color: '#ffffff',
        card_border_color: '#dee2e6',
        input_border_color: '#ced4da',
        input_focus_color: '#80bdff',
        shadow_color: 'rgba(0,0,0,0.15)',
        gradient_start_color: '#007bff',
        gradient_end_color: '#0056b3'
    });
    const [contactSocial, setContactSocial] = useState({});
    const [seo, setSeo] = useState({});
    const [features, setFeatures] = useState({});
    const [payment, setPayment] = useState({});
    const [emailSMScfg, setEmailSMScfg] = useState({});
    const [security, setSecurity] = useState({});
    const [customCode, setCustomCode] = useState({});
    const [tabsest, setTabsest] = useState("Site Settings");
    const [searchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(true);
    const [apisConfig, setApisConfig] = useState({});
    const [userPermissions, setUserPermissions] = useState([]);
    const [whatsappConfig, setWhatsappConfig] = useState({});

    const [userdata, setUserdata] = useState({});
    const [userid, setUserId] = useState("");
    const { sublink } = useParams();  // http://localhost:3000/superadmin/site-settingsnew?tab=payment
    const navigate = useNavigate();

    // Default to India

    // Tab to URL mapping (one source of truth) 
    const tabToUrlMapping = {
        "Site Settings": "site-settings",
        "Colors": "colors",
        "Contact & Social": "contact-social",
        "SEO": "seo",
        "Features": "features",
        "Payment": "payment",
        "Email & SMS config": "email-sms-config",
        "Security": "security",
        "Custom Code": "custom-code",
        "Apis Config": "apis-config",
        "Whatsapp Config": "whatsapp-config"
    };

    const urlToTabMapping = Object.fromEntries(
        Object.entries(tabToUrlMapping).map(([k, v]) => [v, k])
    );

    useEffect(() => {
        const queryTab = searchParams.get("tab"); // read ?tab=payment
        console.log("URL params changed - queryTab:", queryTab, "sublink:", sublink);

        if (queryTab && urlToTabMapping[queryTab]) {
            console.log("Setting tab from query param:", urlToTabMapping[queryTab]);
            setTabsest(urlToTabMapping[queryTab]);
        } else if (sublink && urlToTabMapping[sublink]) {
            console.log("Setting tab from sublink:", urlToTabMapping[sublink]);
            setTabsest(urlToTabMapping[sublink]);
        } else if (sublink === "apis-config") {
            console.log("Setting tab from sublink:", urlToTabMapping[sublink]);
            setTabsest("Apis Config");
        } else if (sublink === "whatsapp-config") {
            console.log("Setting tab from sublink:", urlToTabMapping[sublink]);
            setTabsest("Whatsapp Config");
        } else {
            console.log("Setting default tab: Site Settings");
            setTabsest("Site Settings");
        }
    }, [searchParams, sublink]);

    const handleTabClick = (tabName) => {
        console.log("Tab clicked:", tabName);
        const urlPath = tabToUrlMapping[tabName] || "site-settings";
        console.log("Navigating to:", `/superadmin/site-settingsnew?tab=${urlPath}`);
        setTabsest(tabName);
        navigate(`/superadmin/site-settingsnew?tab=${urlPath}`);
    };



    useEffect(() => {
        getuserdata();
        loadAllData();
    }, []);

    const getuserdata = async () => {
        const response = await getpermissions();
        console.log("response getuserdata settings:", response);
        setUserPermissions(response);
    };

    const loadAllData = async () => {
        setIsLoading(true);
        try {
            const response = await getSettings();
            if (response) {
                setSettings(response);

                // Load color settings
                const colorSettings = {};
                Object.keys(colors).forEach(key => {
                    if (response[key]) {
                        colorSettings[key] = response[key];
                    }
                });
                if (Object.keys(colorSettings).length > 0) {
                    setColors(prev => ({ ...prev, ...colorSettings }));
                }

                // Load contact & social settings
                const contactSocialSettings = {};
                const contactSocialKeys = [
                    'contact_email', 'contact_phone', 'contact_address', 'contact_city', 'contact_state', 'contact_country', 'contact_zip', 'website_url',
                    'facebook_url', 'twitter_url', 'instagram_url', 'linkedin_url', 'youtube_url', 'whatsapp_number', 'telegram_username', 'skype_username',
                    'viber_number', 'snapchat_username', 'tiktok_url', 'pinterest_url', 'reddit_url', 'discord_invite', 'twitch_url',
                    'github_url', 'behance_url', 'dribbble_url', 'medium_url', 'deviantart_url', 'flickr_url', 'tumblr_url', 'vimeo_url',
                    'google_play_url', 'app_store_url', 'microsoft_store_url'
                ];

                contactSocialKeys.forEach(key => {
                    if (response[key]) {
                        contactSocialSettings[key] = response[key];
                    }
                });
                if (Object.keys(contactSocialSettings).length > 0) {
                    setContactSocial(prev => ({ ...prev, ...contactSocialSettings }));
                }

                // Load SEO settings
                const seoSettings = {};
                const seoKeys = [
                    'site_title', 'site_description', 'site_keywords', 'site_author', 'site_robots', 'site_canonical',
                    'og_title', 'og_description', 'og_image', 'og_type', 'og_site_name', 'og_locale',
                    'twitter_card', 'twitter_site', 'twitter_creator', 'twitter_title', 'twitter_description', 'twitter_image',
                    'google_analytics', 'google_tag_manager', 'facebook_pixel', 'google_ads',
                    'schema_type', 'schema_name', 'schema_description', 'schema_url', 'schema_logo', 'schema_contact_point', 'schema_same_as',
                    'custom_meta_tags', 'custom_head_code', 'custom_body_code', 'pages'
                ];

                seoKeys.forEach(key => {
                    if (response[key]) {
                        seoSettings[key] = response[key];
                    }
                });
                if (Object.keys(seoSettings).length > 0) {
                    setSeo(prev => ({ ...prev, ...seoSettings }));
                }

                // Load APIs config from settings if present
                const apisSettings = {};
                const apisKeys = [
                    'facebook_client_id','facebook_client_secret',
                    'google_client_id','google_client_secret',
                    'linkedin_client_id','linkedin_client_secret',
                    'instagram_client_id','instagram_client_secret',
                    'twitter_client_id','twitter_client_secret',
                    'youtube_api_key','oauth_redirect_base_url'
                ];
                
                apisKeys.forEach(key => {
                    if (response[key]) {
                        apisSettings[key] = response[key];
                    }
                });
                if (Object.keys(apisSettings).length > 0) {
                    setApisConfig(prev => ({ ...prev, ...apisSettings }));
                }

                console.log("apisSettings :", apisSettings);
            }
        } catch (error) {
            console.error("Error loading settings:", error);
            toast.error("Failed to load settings");
        } finally {
            setIsLoading(false);
        }
    };


    const handlesubmit = async (e) => {
        if (e) e.preventDefault();
        console.log("Starting site settings handlesubmit. Current settings:", settings);
        setIsLoading(true);

        try {
            if(!hasSiteSettingsPermission({key: "site_settings_edit_settings"})){
                console.warn("Permission denied for editing site settings");
                toast.error("You don't have permission to edit site settings");
                setIsLoading(false);
                return;
            }

            // Validate required fields
            if (!settings.site_name) {
                toast.error("Site name is required");
                setIsLoading(false);
                return;
            }
            if (!settings.site_description) {
                toast.error("Site description is required");
                setIsLoading(false);
                return;
            }

            console.log("Validation passed. Preparing updates...");

            // Save settings using the settings service
            const updates = [];
            Object.keys(settings).forEach(key => {
                if (settings[key] !== null && settings[key] !== undefined) {
                    console.log(`Adding update for key: ${key}`);
                    updates.push(updateSetting(key, settings[key]));
                }
            });

            console.log(`Running ${updates.length} updates...`);
            const results = await Promise.all(updates);
            console.log("Update results:", results);
            const allSuccessful = results.every(result => result);

            if (allSuccessful) {
                toast.success("Site settings updated successfully!");
                await loadAllData(); // Refresh data from DB
            } else {
                toast.error("Some settings failed to update");
            }
        } catch (error) {
            console.error("Error saving site settings in handlesubmit:", error);
            toast.error("An unexpected error occurred: " + error.message);
        } finally {
            setIsLoading(false);
            console.log("Finished site settings handlesubmit");
        }
    };

    const handleColorsSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            // Save color settings
            const updates = Object.keys(colors).map(key =>
                updateSetting(key, colors[key])
            );

            const results = await Promise.all(updates);
            const allSuccessful = results.every(result => result);

            if (allSuccessful) {
                toast.success("Color settings saved successfully!");
            } else {
                toast.error("Some color settings failed to save");
            }
        } catch (error) {
            console.error("Error saving color settings:", error);
            toast.error("Failed to save color settings");
        } finally {
            setIsLoading(false);
        }
    };

    const handleContactSocialSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            // Save contact & social settings
            const updates = Object.keys(contactSocial).map(key =>
                updateSetting(key, contactSocial[key])
            );

            const results = await Promise.all(updates);
            const allSuccessful = results.every(result => result);

            if (allSuccessful) {
                toast.success("Contact & Social settings saved successfully!");
            } else {
                toast.error("Some contact & social settings failed to save");
            }
        } catch (error) {
            console.error("Error saving contact & social settings:", error);
            toast.error("Failed to save contact & social settings");
        } finally {
            setIsLoading(false);
        }
    };

    const handleSEOSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            // Save SEO settings
            const updates = Object.keys(seo).map(key =>
                updateSetting(key, seo[key])
            );

            const results = await Promise.all(updates);
            const allSuccessful = results.every(result => result);

            if (allSuccessful) {
                toast.success("SEO settings saved successfully!");
            } else {
                toast.error("Some SEO settings failed to save");
            }
        } catch (error) {
            console.error("Error saving SEO settings:", error);
            toast.error("Failed to save SEO settings");
        } finally {
            setIsLoading(false);
        }
    };

    const handleFeaturesSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            // Save features settings using updateMultipleSettings for proper type detection
            const success = await updateMultipleSettings(features);

            if (success) {
                toast.success("Features settings saved successfully!");
            } else {
                toast.error("Some features settings failed to save");
            }
        } catch (error) {
            console.error("Error saving features settings:", error);
            toast.error("Failed to save features settings");
        } finally {
            setIsLoading(false);
        }
    };

    const handlePaymentSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            // Save payment settings using updateMultipleSettings for proper type detection
            const success = await updateMultipleSettings(payment);

            if (success) {
                toast.success("Payment settings saved successfully!");
            } else {
                toast.error("Some payment settings failed to save");
            }
        } catch (error) {
            console.error("Error saving payment settings:", error);
            toast.error("Failed to save payment settings");
        } finally {
            setIsLoading(false);
        }
    };

    const handleEmailSMScfgSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            // Save email & SMS settings using updateMultipleSettings for proper type detection
            const success = await updateMultipleSettings(emailSMScfg);

            if (success) {
                toast.success("Email & SMS settings saved successfully!");
            } else {
                toast.error("Some email & SMS settings failed to save");
            }
        } catch (error) {
            console.error("Error saving email & SMS settings:", error);
            toast.error("Failed to save email & SMS settings");
        } finally {
            setIsLoading(false);
        }
    };

    const handleSecuritySubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            // Save security settings using updateMultipleSettings for proper type detection
            const success = await updateMultipleSettings(security);

            if (success) {
                toast.success("Security settings saved successfully!");
            } else {
                toast.error("Some security settings failed to save");
            }
        } catch (error) {
            console.error("Error saving security settings:", error);
            toast.error("Failed to save security settings");
        } finally {
            setIsLoading(false);
        }
    };

    const handleCustomCodeSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            // Save custom code settings using updateMultipleSettings for proper type detection
            const success = await updateMultipleSettings(customCode);

            if (success) {
                toast.success("Custom code settings saved successfully!");
            } else {
                toast.error("Some custom code settings failed to save");
            }
        } catch (error) {
            console.error("Error saving custom code settings:", error);
            toast.error("Failed to save custom code settings");
        } finally {
            setIsLoading(false);
        }
    };

    const hasSiteSettingsPermission = ({key}) => {
        if(userPermissions === "administrator"){
            return true;
        }
        if (!Array.isArray(userPermissions)) {
            console.warn("userPermissions is not an array:", userPermissions);
            return false;
        }
        const hasPermission = userPermissions.some(permission => permission && permission.value === key);
        return hasPermission;
    };



    return (
        <>
            <div className="subbody" style={{ width: '100%', padding: '2% 4%' }}>
                {isLoading ? (
                    <Preloader />
                ) : (
                    <>
                        {userdata.activation_key == null && (
                            <EmailVerify />
                        )}

                        <section className="dc-haslayout dc-dbsectionspace">
                            <div className="row">
                                <div className={`col-xs-12 col-sm-12 col-md-12  ${tabsest == "SEO" ? "col-lg-12 col-xl-12" : "col-lg-8 col-xl-9"}`}>
                                    <form className="dc-user-profile" method="post">
                                        <div className="dc-dashboardbox dc-dashboardtabsholder">
                                            <div className="dc-dashboardboxtitle">
                                                <h2>{tabsest}</h2>
                                            </div>
                                            <div className="dc-dashboardtabs">
                                                <ul className="dc-tabstitle nav navbar-nav">
                                                    {hasSiteSettingsPermission({key: "site_settings"}) && (
                                                        <li className="nav-item">
                                                            <a className={`${tabsest == "Site Settings" ? 'active' : ''} `}
                                                                href="#"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleTabClick("Site Settings");
                                                                }}>
                                                                Site Settings
                                                            </a>
                                                        </li>
                                                    )}
                                                    {hasSiteSettingsPermission({key: "color_settings"}) && (
                                                    <li className="nav-item">
                                                        <a className={`${tabsest == "Colors" ? 'active' : ''} `}
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleTabClick("Colors");
                                                            }}>
                                                            Colors
                                                        </a>
                                                    </li>
                                                    )}
                                                    {hasSiteSettingsPermission({key: "contact_social_settings"}) && (
                                                    <li className="nav-item">
                                                        <a className={`${tabsest == "Contact & Social" ? 'active' : ''} `}
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleTabClick("Contact & Social");
                                                            }}>
                                                            Contact &amp; Social
                                                        </a>
                                                    </li>
                                                    )}
                                                    {hasSiteSettingsPermission({key: "seo_settings"}) && (
                                                    
                                                    <li className="nav-item">
                                                        <a className={`${tabsest == "SEO" ? 'active' : ''} `}
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleTabClick("SEO");
                                                            }}>
                                                            SEO
                                                        </a>
                                                    </li>
                                                    )}
                                                    {hasSiteSettingsPermission({key: "features_settings"}) && (
                                                    <li className="nav-item">
                                                        <a className={`${tabsest == "Features" ? 'active' : ''} `}
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleTabClick("Features");
                                                            }}>
                                                            Features
                                                        </a>
                                                    </li>
                                                    )}
                                                    {hasSiteSettingsPermission({key: "payment_settings"}) && (
                                                    <li className="nav-item">
                                                        <a className={`${tabsest == "Payment" ? 'active' : ''} `}
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleTabClick("Payment");
                                                            }}>
                                                            Payment
                                                        </a>
                                                    </li>
                                                    )}
                                                    {hasSiteSettingsPermission({key: "email_sms_settings"}) && (
                                                    <li className="nav-item">
                                                        <a className={`${tabsest == "Email & SMS config" ? 'active' : ''} `}
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleTabClick("Email & SMS config");
                                                            }}>
                                                            Email &amp; SMS config
                                                        </a>
                                                    </li>
                                                    )}
                                                    {hasSiteSettingsPermission({key: "security_settings"}) && (
                                                    <li className="nav-item">
                                                        <a className={`${tabsest == "Security" ? 'active' : ''} `}
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleTabClick("Security");
                                                            }}>
                                                            Security
                                                        </a>
                                                    </li>
                                                    )}
                                                    {hasSiteSettingsPermission({key: "apis_settings"}) && (
                                                    <li className="nav-item">
                                                        <a className={`${tabsest == "Apis Config" ? 'active' : ''} `}
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleTabClick("Apis Config");
                                                            }}>
                                                            Apis Configs
                                                        </a>
                                                    </li>
                                                    )}
                                                    {hasSiteSettingsPermission({key: "custom_code_settings"}) && (
                                                    <li className="nav-item">
                                                        <a className={`${tabsest == "Custom Code" ? 'active' : ''} `}
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleTabClick("Custom Code");
                                                            }}>
                                                            Custom Code
                                                        </a>
                                                    </li>
                                                    )}
                                                    {hasSiteSettingsPermission({key: "whatsapp_config_settings"}) && (
                                                    <li className="nav-item">
                                                        <a className={`${tabsest == "Whatsapp Config" ? 'active' : ''} `}
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleTabClick("Whatsapp Config");
                                                            }}>
                                                            Whatsapp Config
                                                        </a>
                                                    </li>
                                                    )}
                                                </ul>
                                            </div>
                                            <div className="dc-tabscontentwrapper">
                                                {tabsest === "Site Settings" && (
                                                    <SiteSettings settings={settings} setSettings={setSettings} />
                                                )}

                                                {tabsest === "Colors" && (
                                                    <Colors colors={colors} setColors={setColors} />
                                                )}

                                                {tabsest === "Contact & Social" && (
                                                    <ContactSocial contactSocial={contactSocial} setContactSocial={setContactSocial} />
                                                )}

                                                {tabsest === "SEO" && (
                                                    <SEO seo={seo} setSeo={setSeo} />
                                                )}

                                                {tabsest === "Features" && (
                                                    <Features features={features} setFeatures={setFeatures} />
                                                )}

                                                {tabsest === "Payment" && (
                                                    <Payment payment={payment} setPayment={setPayment} />
                                                )}

                                                {tabsest === "Email & SMS config" && (
                                                    <EmailSMScfg emailSMScfg={emailSMScfg} setEmailSMScfg={setEmailSMScfg} />
                                                )}

                                                {tabsest === "Security" && (
                                                    <Security security={security} setSecurity={setSecurity} />
                                                )}

                                                {tabsest === "Custom Code" && (
                                                    <CustomCode customCode={customCode} setCustomCode={setCustomCode} />
                                                )}

                                                {tabsest === "Apis Config" && (
                                                    <ApisConfig apisConfig={apisConfig} setApisConfig={setApisConfig} />
                                                )}

                                                {tabsest === "Whatsapp Config" && (
                                                    <WhatsappConfig whatsappConfig={whatsappConfig} setWhatsappConfig={setWhatsappConfig} />
                                                )}
                                            </div>
                                        </div>
                                        <div className="dc-updatall">
                                            <i className="ti-announcement"></i>
                                            <span>Update all the latest changes made by you, by just clicking on Save &amp; Update button.</span>
                                            <a
                                                className="dc-btn dc-update-profile-doctorss"
                                                data-id="4174"
                                                data-post="18128"
                                                href="#"
                                                onClick={async (e) => {
                                                    e.preventDefault();
                                                    console.log("Save & Update clicked for tab:", tabsest);
                                                    try {
                                                        switch (tabsest) {
                                                            case "Site Settings":
                                                                await handlesubmit(e);
                                                                break;
                                                            case "Colors":
                                                                await handleColorsSubmit(e);
                                                                break;
                                                            case "Contact & Social":
                                                                await handleContactSocialSubmit(e);
                                                                break;
                                                            case "SEO":
                                                                await handleSEOSubmit(e);
                                                                break;
                                                            case "Features":
                                                                await handleFeaturesSubmit(e);
                                                                break;
                                                            case "Payment":
                                                                await handlePaymentSubmit(e);
                                                                break;
                                                            case "Email & SMS config":
                                                                await handleEmailSMScfgSubmit(e);
                                                                break;
                                                            case "Security":
                                                                await handleSecuritySubmit(e);
                                                                break;
                                                            case "Custom Code":
                                                                await handleCustomCodeSubmit(e);
                                                                break;
                                                            case "Apis Config": {
                                                                // Save apisConfig settings
                                                                const success = await updateMultipleSettings(apisConfig);
                                                                if (success) {
                                                                    toast.success("APIs settings saved successfully!");
                                                                } else {
                                                                    toast.error("Some APIs settings failed to save");
                                                                }
                                                                break;
                                                            }
                                                            default:
                                                                console.warn("Unknown tab:", tabsest);
                                                                break;
                                                        }
                                                    } catch (err) {
                                                        console.error("Error in Save & Update click handler:", err);
                                                        toast.error("Operation failed: " + err.message);
                                                    }
                                                }}
                                            >
                                                Save &amp; Update
                                            </a>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </section>
                    </>
                )}
            </div>
        </>
    );
};

export default SuperAdminSiteSettings;
